import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';
import { InputNumber, Tooltip } from '@meitu/saas-ui';
import { parseToPixels, SizeUnitPrecision, SizeUnitType } from '@meitu/saas-editor-core/es/utils/unit-kit';
import { MIN_STAGE_HEIGHT, MIN_STAGE_WIDTH } from '@meitu/saas-editor-core/es/version-types';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import './index.less';

type SizeUnit = 'small' | 'large';
interface IProps extends HTMLAttributes<HTMLDivElement> {
    widthSize: number;
    heightSize: number;
    lockRatio: boolean;
    unit: SizeUnitType;
    size?: SizeUnit;
    onChangeWidth?: (val: number) => void;
    onChangeHeight?: (val: number) => void;
    onChangeLock?: () => void;
}
const SizeInfo: React.FC<IProps> = (props) => {
    const {
        widthSize,
        heightSize,
        unit,
        size = 'large',
        lockRatio = true,
        onChangeWidth,
        onChangeHeight,
        onChangeLock,
    } = props;

    const { $t } = useLocaleStore();

    const isLarge = size === 'large';
    const inputWidth = isLarge ? 95 : 68;

    const handleBlur = (value: number, type: 'width' | 'height') => {
        if (!value) return;
        const pxValue = parseToPixels(value || 20, unit);
        if (type === 'width' && pxValue < MIN_STAGE_WIDTH) {
            onChangeWidth?.(MIN_STAGE_WIDTH);
        } else if (type === 'height' && pxValue < MIN_STAGE_HEIGHT) {
            onChangeHeight?.(MIN_STAGE_HEIGHT);
        }
    };
    return (
        <div className="c-adjust-size-panel-info">
            <InputNumber
                enableMouseWheel={false}
                value={widthSize}
                precision={SizeUnitPrecision[unit]}
                showStepBtn={false}
                onChange={(val: number | null) => {
                    const pxValue = parseToPixels(val || 20, unit);
                    if (!val || pxValue < MIN_STAGE_WIDTH) return;
                    onChangeWidth?.(val);
                }}
                onBlur={(e) => handleBlur(+e.target?.value, 'width')}
                suffix={$t((v) => v.panel.backgroundPanel.width)}
                style={{ width: inputWidth, height: 34 }}
            />

            <Tooltip
                placement="bottom"
                title={
                    lockRatio
                        ? $t((v) => v.panel.backgroundPanel.lockRatio)
                        : $t((v) => v.panel.backgroundPanel.customRatio)
                }
                getPopupContainer={(el) => el.parentNode as HTMLElement}
            >
                <div
                    className={classNames('c-adjust-size-panel-info__icon', {
                        locked: lockRatio,
                    })}
                    style={{ margin: isLarge ? '' : '0 4px' }}
                    onClick={() => {
                        onChangeLock?.();
                    }}
                >
                    <IconFont name={lockRatio ? 'LockBold' : 'UnlockBold'} fontSize={16} />
                </div>
            </Tooltip>

            <InputNumber
                enableMouseWheel={false}
                value={heightSize}
                precision={SizeUnitPrecision[unit]}
                showStepBtn={false}
                onChange={(val: number | null) => {
                    const pxValue = parseToPixels(val || 20, unit);
                    if (!val || pxValue < MIN_STAGE_HEIGHT) return;
                    onChangeHeight?.(val);
                }}
                onBlur={(e) => handleBlur(+e.target?.value, 'height')}
                suffix={$t((v) => v.panel.backgroundPanel.height)}
                style={{ width: inputWidth, height: 34 }}
            />
        </div>
    );
};
export default React.memo(SizeInfo);
